module.exports = __webpack_public_path__ + "ebcff628df50449f78d6e3753f586765.png";